import { safeLocalStorage } from './safeLocalStorage';

export const RELEASE_DEBUG_LOGGING_STORAGE_KEY = 'debug:release-upload';

type DebugFlagStorage = Pick<Storage, 'getItem'>;
type DebugFlagEnvironment = Record<string, string | boolean | undefined>;

function isEnabledValue(value: string | boolean | null | undefined): boolean {
  if (typeof value === 'boolean') {
    return value;
  }

  switch (value?.trim().toLowerCase()) {
    case '1':
    case 'true':
    case 'yes':
    case 'on':
      return true;
    default:
      return false;
  }
}

function getViteEnv(): DebugFlagEnvironment {
  return (import.meta.env ?? {}) as DebugFlagEnvironment;
}

export function isReleaseDebugLoggingEnabled(
  storage: DebugFlagStorage = safeLocalStorage,
  env: DebugFlagEnvironment = getViteEnv(),
): boolean {
  if (
    isEnabledValue(env.VITE_RELEASE_UPLOAD_DEBUG) ||
    isEnabledValue(env.VITE_RELEASE_DEBUG)
  ) {
    return true;
  }

  try {
    return isEnabledValue(storage.getItem(RELEASE_DEBUG_LOGGING_STORAGE_KEY));
  } catch {
    return false;
  }
}

export function releaseDebugLog(...args: unknown[]): void {
  if (!isReleaseDebugLoggingEnabled()) {
    return;
  }

  console.log(...args);
}
